export default [
    {path: '/form', component: () => import('@/views/form/MyDemo.vue')},
    {path: '/automaticTerminal/:address', component: () => import('@/views/applications/automatic/AutomaticTerminal.vue'), notLogin: true},
    {path: '/fcDesigner', component: () => import('@/views/applications/frameTest/fromDesigner/FCDesigner.vue'), notLogin: true},
    {path: '/selfDesigner', component: () => import('@/views/applications/frameTest/fromDesigner/FrameFormDesigner.vue'), notLogin: true}
]